/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const GovernmentCircled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Government circled"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.25 0a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        d="M11.418 7.306a1.25 1.25 0 0 1 1.164 0l3.677 1.935c.433.228.27.884-.219.884H7.96c-.49 0-.652-.656-.219-.884z"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M11.063 10.75c.345 0 .624.28.624.625v2.5a.625.625 0 1 1-1.25 0v-2.5c0-.345.28-.625.626-.625m1.875 0c.345 0 .624.28.624.625v2.5a.625.625 0 1 1-1.25 0v-2.5c0-.345.28-.625.626-.625m3.437 5c0 .345-.28.625-.625.625h-7.5a.625.625 0 1 1 0-1.25h7.5c.345 0 .625.28.625.625m-7.187-5c.345 0 .624.28.624.625v2.5a.625.625 0 1 1-1.25 0v-2.5c0-.345.28-.625.626-.625m5.625 0c.345 0 .624.28.624.625v2.5a.625.625 0 1 1-1.25 0v-2.5c0-.345.28-.625.626-.625"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        d="M20.333 12A8.333 8.333 0 1 0 12 20.333V22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10v-1.667A8.333 8.333 0 0 0 20.333 12"
      />
    </g>
  </svg>
);

export const GovernmentCircledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'government-circled-icon'}
      icon={GovernmentCircled}
      {...props}
      size={size}
    />
  );
};
